import React from 'react'
import {Box, Flex, Image, Text, useMultiStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {parseAndSanitizeJSONWithSpaces} from '../../utils/utils'
import {getDamBaseUrl} from '../../custom-hooks/use-dam-image'

const Features = ({features}) => {
    const styles = useMultiStyleConfig('Features')
    const baseUrl = getDamBaseUrl()

    return (
        <Flex {...styles.outerContainer}>
            <Text as="h2" {...styles.headerLabel}>
                <FormattedMessage defaultMessage="Features" id="features.heading" />
            </Text>
            <Flex {...styles.elementsGrid}>
                {parseAndSanitizeJSONWithSpaces(features).map((feature, i) => {
                    return (
                        <Box key={i} {...styles.featureBox}>
                            <Image
                                src={`${baseUrl}/${feature?.imageLink}`}
                                alt=""
                                {...styles.elementImage}
                            />
                            <Flex {...styles.textContainer}>
                                <Text {...styles.title}>{feature?.title}</Text>
                                <Text {...styles.description}>{feature?.description}</Text>
                            </Flex>
                        </Box>
                    )
                })}
            </Flex>
        </Flex>
    )
}

Features.propTypes = {
    features: PropTypes.string.isRequired,
}

export default Features
